import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";

import AgentLayer from "../components/AgentLayer";



const AgentPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Agent Setup" />

        <AgentLayer/>

      </MasterLayout>

    </>
  );
};

export default AgentPage; 
